/* eslint-disable no-template-curly-in-string */
import { useEffect, useState } from 'react';
import GoogleTagManager from 'react-gtm-module';
import * as yup from 'yup';
import * as Sentry from '@sentry/react';

import { ENVIRONMENT, INTEGRATION_SETTINGS } from '../../../../constants';
import { useTenantedApplicationConfig } from '../../../../contexts';
import { isProductionEnv } from '../../../../utils/environment';

export const useAppProviders = () => {
  const { documentTitle } = useTenantedApplicationConfig();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const { appEnv } = ENVIRONMENT;

    if (INTEGRATION_SETTINGS.sentry.dsn) {
      Sentry.init({
        environment: appEnv,
        dsn: INTEGRATION_SETTINGS.sentry.dsn,
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: isProductionEnv() ? 0.25 : 1.0,
      });
      Sentry.setTag('tenant', ENVIRONMENT.tenant);
    }

    if (isProductionEnv() && INTEGRATION_SETTINGS.gtm.id) {
      GoogleTagManager.initialize({ gtmId: INTEGRATION_SETTINGS.gtm.id });
    }

    yup.setLocale({
      mixed: {
        oneOf: 'This is a required field',
        required: 'This is a required field',
      },
      string: {
        email: 'This field must be a valid email',
        length: 'This field must have exactly ${length} characters',
        max: 'This field cannot exceed ${max} characters',
        min: 'This field must have a minimum of ${min} characters',
      },
    });

    setIsReady(true);
  }, []);

  return {
    documentTitle,
    isReady,
  };
};
